import Layout from "@/components/Layout/Layout";
import { Premium } from "@/features/subscription";
import type { NextPageWithLayout } from "@/pages/_app";
import Head from "next/head";
import type { ReactElement } from "react";

const PremiumPage: NextPageWithLayout = () => {
	return (
		<>
			<Head>
				<title>ケアミープレミアム</title>
			</Head>

			<Premium />
		</>
	);
};

PremiumPage.getLayout = function getLayout(page: ReactElement) {
	return <Layout hideHeader>{page}</Layout>;
};

export default PremiumPage;
